import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=cc4845d8&scoped=true&"
import script from "./Rules.vue?vue&type=script&lang=js&"
export * from "./Rules.vue?vue&type=script&lang=js&"
import style0 from "./Rules.vue?vue&type=style&index=0&id=cc4845d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4845d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc4845d8')) {
      api.createRecord('cc4845d8', component.options)
    } else {
      api.reload('cc4845d8', component.options)
    }
    module.hot.accept("./Rules.vue?vue&type=template&id=cc4845d8&scoped=true&", function () {
      api.rerender('cc4845d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/rules/Rules.vue"
export default component.exports